import { Check, Trash2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function ActionBar({
  onSave,
  onDiscard,
  fixed = true,
  saveDisabled = false,
  saveDisabledLabel = null,
  saveLabel = null,
  checkboxSave = false,
}) {
  const { t } = useLanguage();

  return (
    <div
      className={`${
        fixed ? 'fixed bottom-0 left-0 right-0 z-40' : 'shrink-0 rounded-b-[24px]'
      } border-t border-gray-200 bg-white px-4 py-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] pb-[calc(0.75rem+env(safe-area-inset-bottom))]`}
    >
      {saveDisabled && saveDisabledLabel ? (
        <p className="mb-2 text-center text-xs font-medium text-amber-700">
          {saveDisabledLabel}
        </p>
      ) : null}

      <div className="flex w-full items-center justify-between gap-3">
        <button
          type="button"
          onClick={onDiscard}
          aria-label={t('discard')}
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-500 transition-colors hover:bg-gray-200"
        >
          <Trash2 className="h-5 w-5" strokeWidth={2} />
        </button>

        {checkboxSave ? (
          <button
            type="button"
            onClick={saveDisabled ? undefined : onSave}
            disabled={saveDisabled}
            aria-label={
              saveDisabled
                ? (saveDisabledLabel || t('saveToSession'))
                : t('saveToSession')
            }
            className={`flex h-12 w-12 items-center justify-center rounded-full shadow-md transition-colors ${
              saveDisabled
                ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                : 'bg-success text-white hover:bg-success-dark'
            }`}
          >
            <Check className="h-6 w-6" strokeWidth={2.5} />
          </button>
        ) : saveLabel ? (
          <button
            type="button"
            onClick={saveDisabled ? undefined : onSave}
            disabled={saveDisabled}
            className={`min-w-0 flex-1 rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
              saveDisabled
                ? 'cursor-not-allowed bg-gray-200 text-gray-500'
                : 'bg-primary text-white hover:bg-primary-hover'
            }`}
          >
            {saveDisabled
              ? (saveDisabledLabel || t('recordToCompleteTask'))
              : saveLabel}
          </button>
        ) : (
          <button
            type="button"
            onClick={saveDisabled ? undefined : onSave}
            disabled={saveDisabled}
            aria-label={
              saveDisabled
                ? (saveDisabledLabel || t('saveToSession'))
                : t('saveToSession')
            }
            className={`flex h-12 w-12 items-center justify-center rounded-full shadow-md transition-colors ${
              saveDisabled
                ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                : 'bg-success text-white hover:bg-success-dark'
            }`}
          >
            <Check className="h-6 w-6" strokeWidth={2.5} />
          </button>
        )}
      </div>
    </div>
  );
}
